import { render, staticRenderFns } from "./EPMultiplierButton.vue?vue&type=template&id=56481ae6&scoped=true&"
import script from "./EPMultiplierButton.vue?vue&type=script&lang=js&"
export * from "./EPMultiplierButton.vue?vue&type=script&lang=js&"
import style0 from "./EPMultiplierButton.vue?vue&type=style&index=0&id=56481ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56481ae6",
  null
  
)

export default component.exports